import { GLCode } from '@rygen/rygen-ui/model';

/**
 * This class is a hack to send multiple `GLCode`s in a search request
 *
 * Our search functionality uses query params to track a user's search params.
 * The entire URL is sent in the `Referer` header and has a maximum length of
 * 4096 bytes, which we can go over by sending too many GLCodes. This class has
 * the same shape as `GLCode` and can be deserialized as a GLCode on the backend,
 * but sends only the code.
 *
 * **Note:** This class is only for search requests. You probably shouldn't
 * use it for anything else.
 */
export class SlimGLCode {
  code?: string;

  constructor(opts?: Partial<SlimGLCode | GLCode>) {
    if (opts?.code != null) {
      this.code = opts.code;
    }
  }
}
